import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";

export const decoColumns = ({ handleRowActions }) => {

    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "450px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className="fw-bold"
                    id={`life-cycle-name-${row._id}`}
                    max={100}/>
            )
        },
        {
            name    : "Description",
            selector: (row) => row.description,
            width   : "450px",
            cell    : row => (
                <LongNameFormatter
                    content={row.description}
                    id={`life-cycle-description-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Min Days",
            selector: (row) => row.minDays,
            width   : "150px",
            cell    : (row) => <span>{row.minDays}</span>
        },
        {
            name    : "Max Days",
            selector: (row) => row.maxDays,
            width   : "150px",
            cell    : (row) => <span>{row.maxDays}</span>
        },
        {
            name    : "On Track",
            selector: (row) => row.onTrackCount,
            width   : "150px",
            cell    : (row) => (
                <p className="fw-bolder">
                    {row.onTrackCount}
                </p>
            )
        },
        {
            name    : "Behind",
            selector: (row) => row.behindCount,
            width   : "150px",
            cell    : (row) => (
                <p className="fw-bolder">
                    {row.behindCount}
                </p>
            )
        },
        {
            name    : "Stuck",
            selector: (row) => row.stuckCount,
            width   : "150px",
            cell    : (row) => (
                <p className="fw-bolder">
                    {row.stuckCount}
                </p>
            )
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};